<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1" id="_idContainer001">
<p class="ORIM-Book-Title--Front-Matter-" id="_idParaDest-1" lang="en-US"><span class="CharOverride-3"><a id="_idTextAnchor000"></a>THE LIGHT OF SEVEN DAYS</span></p>
<p class="ORIM-Book-Subtitle--Front-Matter-" lang="en-US"><span class="CharOverride-3">A Novel</span></p>
<p class="ORIM-Author-Name--Front-Matter-" lang="en-US"><span class="CharOverride-3">River Adams</span></p>
<p class="Normal ParaOverride-2" lang="en-US"><span class="CharOverride-4"><img src="image/logo.jpg"/></span></p>
<br/>
<p class="Normal ParaOverride-2" lang="en-US"><span class="CharOverride-4"><img src="image/delogo.jpg"/></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Untitled234.vue?35c90de9